var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('va-create-layout',[_c(_setup.Form,{attrs:{"title":_vm.title,"item":_setup.newExercise ?? _vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }